// ЦЕПОЧКА САБМИТА — B10-4 `3e919875cbb88145ae08dc284bce1122`, вариант Б `s929.d1` (Кирилл, 28.09).
//
// Порядок не переставляется: конверт → `toWizardInput` → `wizardSubmitCheck` → ТОЛЬКО при `ok` →
// `buildPassport`. Зовёт её `onCta` close-блока шага 6 (`StepSix.jsx`) — не оболочка: правило шага в
// чужой полосе проект уже дважды отказывался заводить (`footerNav` / `publishGate`). Кэша нет: паспорт
// строится здесь ради проверки и заново на маунте шага 7 (`s472.d2` исполняется, не переиздаётся).
//
// ⭐ ОТКАЗ — ЭТО АДРЕС И СЛОТ, А НЕ БРОСОК. Человек на шаге 6 прошёл двенадцать минут работы; цепочка
// не роняет экран, а говорит, куда вернуться (`address`, B10-2) и что сказать (`slot`, B10-3).
//   · бросок `toWizardInput` → слот 4 `submit.envelope` (п. 2 тикета), адреса нет;
//   · проблема без адреса (`step: 0`: потолок этапов, пустые ползунки) → тот же слот 4, адреса нет;
//   · проблема с адресом → её слот и её адрес. Из нескольких берётся ПЕРВАЯ АДРЕСУЕМАЯ: её человек
//     может починить, следующая всплывёт на следующем нажатии.
// Адреса нет → вызывающий ведёт на шаг 1, где под непустым конвертом стоит `start over` (B3-4) — то
// действие, которое называет слот 4.
//
// ⭐ ТЕКСТ И КНОПКИ ДЕКИ ВЫРАВНИВАЮТСЯ ПО ЧИСЛУ ЭТАПОВ, И ЭТО НЕ ПРЯТКА ПОВРЕЖДЕНИЙ. Дека пишет ряды
// панелей B/C только при касании (`StepThree.jsx` `writeText` / `toggle`), обе панели необязательны.
// Человек, не открывший панель C, несёт `text: []`, а контракт требует длину = числу ползунков
// (`contracts.js` `wizard.text length … != sliders`) — без выравнивания честный путь падал бы в слот 4
// «начни заново». Ряд, которого нет, читается пустым — ровно как его читает сама дека (`textAt` /
// `groupsAt` / `custAt`). Длины этапов и ползунков НЕ выравниваются: их рассинхрон — повреждение, и
// его громко ловит `toWizardInput`.

import { toWizardInput, GROUP_IDS } from './toWizardInput.js';
import { wizardSubmitCheck } from './submitCheck.js';
import { slotOf, slotOfError } from './submitCopy.js';
import { buildPassport } from '../render/passportData.js';

const ENVELOPE = 'submit.envelope';

export const textAt = (rows, i) => {
  const r = Array.isArray(rows) ? rows[i] : null;
  if (!r || typeof r !== 'object' || Array.isArray(r)) return { T1: '', T2: '', T3: '' };
  return { T1: typeof r.T1 === 'string' ? r.T1 : '', T2: typeof r.T2 === 'string' ? r.T2 : '', T3: typeof r.T3 === 'string' ? r.T3 : '' };
};
export const groupsAt = (rows, i) => {
  const r = Array.isArray(rows) ? rows[i] : null;
  const ok = r && typeof r === 'object' && !Array.isArray(r);
  return Object.fromEntries(GROUP_IDS.map((id) => [id, ok && Array.isArray(r[id]) ? r[id] : []]));
};
export const custAt = (rows, i) => (Array.isArray(rows) && typeof rows[i] === 'string' ? rows[i] : '');

/**
 * Конверт → `WizardInput`. Бросает то же, что `toWizardInput` (рассинхрон этапов и ползунков, этап без даты).
 * @param {{nowY: number, input: {stages: Array, sliders: Array, text?: Array, buttons?: Array, cust?: Array}}} session
 */
export function inputOfSession(session) {
  const { stages, sliders, text, buttons, cust } = session.input;
  const n = Array.isArray(sliders) ? sliders.length : 0;
  const at = (fn, rows) => Array.from({ length: n }, (_, k) => fn(rows, k));
  return toWizardInput(
    { rows: stages },
    { vals: sliders, text: at(textAt, text), grp: at(groupsAt, buttons), cust: at(custAt, cust) },
    { nowY: session.nowY },
  );
}

/**
 * Прогон цепочки на нажатии CTA шага 6.
 *
 * @param {object} session конверт визарда
 * @param {{build?: typeof buildPassport}} [deps] `build` подменяется только тестом (счёт вызовов)
 * @returns {{ok: true, passport: object} | {ok: false, slot: string, address: string|null}}
 */
export function runSubmit(session, { build = buildPassport } = {}) {
  let input;
  try {
    input = inputOfSession(session);
  } catch (e) {
    return { ok: false, slot: slotOfError(e) ?? ENVELOPE, address: null };
  }
  const check = wizardSubmitCheck(input);
  if (!check.ok) {
    const hit = check.problems.find((p) => p.address && slotOf(p)) || null;
    if (hit) return { ok: false, slot: slotOf(hit), address: hit.address };
    return { ok: false, slot: ENVELOPE, address: null };
  }
  return { ok: true, passport: build(input) };
}
